/*
 * Copyright (C) 2017-2019 Dremio Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Colors
export const PRIMARY = "primary";
export const SECONDARY = "secondary";
export const WARNING = "warn";
export const DEFAULT = "default";

// Variants
export const CONTAINED = "contained";
export const OUTLINED = "outlined";
export const TEXT = "text";

export const COLORS_ARRAY = [PRIMARY, SECONDARY, DEFAULT, WARNING];

export const VARIANTS_ARRAY = [OUTLINED, CONTAINED, TEXT];
